module.exports = __webpack_public_path__ + "static/media/McKinseySans-MediumItalic.f74455c6.woff";